import { ga, mixpanel } from '@domain-group/fe-co-allhomes-analytics';
import { ListingType } from '@domain-group/fe-allhomes-library';
import * as ga4 from './ga4-handlers';
import { GAActions, GALabels } from './constants';
var SearchTypeMap = {
  SCHOOL: GALabels.SCHOOL_SEARCH,
  DEVELOPMENT: GALabels.PROJECT_SEARCH,
  ADDRESS: GALabels.ADDRESS_SEARCH
};
var MixpanelLabels = {
  VIEW_DISTRICT_PROFILE: 'View District Profile',
  VIEW_SUBURB_PROFILE: 'View Suburb Profile'
};
var eventMapper = {
  ["/autocomplete-search/"]: (_key, _ref) => {
    var _ListingType$listingT, _ListingType$listingT2;
    var listingType = _ref.listingType,
      items = _ref.items;
    var autocompleteItems = items;
    var label = '';
    var searchTerm = '';
    var listingCategory = (_ListingType$listingT = (_ListingType$listingT2 = ListingType[listingType]) === null || _ListingType$listingT2 === void 0 ? void 0 : _ListingType$listingT2.category) !== null && _ListingType$listingT !== void 0 ? _ListingType$listingT : '';
    if (autocompleteItems.length > 0) {
      var firstItem = autocompleteItems[0];
      label = SearchTypeMap[firstItem.type];
      searchTerm = autocompleteItems.map(item => item.name).join(', ');
    }
    return [ga.interaction(GAActions.SEARCH_BUTTON), ...(label ? [ga.typeahead(GAActions.HOMEPAGE, label)] : []), ga4.autocompleteSearchEvent({
      searchTerm,
      listingCategory
    })];
  },
  ["/show-tooltip/"]: () => ga.typeahead(GAActions.HOMEPAGE, GALabels.SCHOOL_SEARCH_TOOLTIP_APPEAR),
  ["/close-tooltip/"]: () => ga.typeahead(GAActions.HOMEPAGE, GALabels.SCHOOL_SEARCH_TOOLTIP_CLOSE),
  ["/display-research-cta/"]: () => mixpanel.displayResearchCta({
    interactionCTA: MixpanelLabels.VIEW_DISTRICT_PROFILE
  }),
  'explore-research-cta': (_key, data) => [mixpanel.clickResearchCta({
    interactionCTA: MixpanelLabels.VIEW_SUBURB_PROFILE
  }), ga4.exploreSuburbProfiles(data)],
  'click-research-cta': (_key, data) => [mixpanel.clickResearchCta({
    interactionCTA: MixpanelLabels.VIEW_DISTRICT_PROFILE
  }), ga4.viewDistrictProfile(data)],
  ["/view-article-click/"]: (_key, _ref2) => {
    var sectionName = _ref2.sectionName,
      index = _ref2.index;
    return ga.interaction("".concat(sectionName, " Article - Position ").concat(index + 1));
  },
  ["/news-tab-click/"]: (_key, _ref3) => {
    var tabLabel = _ref3.tabLabel;
    return ga.interaction("".concat(GALabels.NEWS_TAB, " - ").concat(tabLabel));
  },
  'mobile-recent-item-click': (_key, data) => {
    var _ListingType$listingT3, _ListingType$listingT4, _item$position;
    var listingType = data.listingType,
      item = data.item;
    var listingCategory = (_ListingType$listingT3 = (_ListingType$listingT4 = ListingType[listingType]) === null || _ListingType$listingT4 === void 0 ? void 0 : _ListingType$listingT4.category) !== null && _ListingType$listingT3 !== void 0 ? _ListingType$listingT3 : '';
    return ga4.recentSearchEvent({
      recentSearchPosition: (_item$position = item.position) !== null && _item$position !== void 0 ? _item$position : 0,
      label: item.name,
      listingCategory
    });
  },
  'recent-item-click': (_key, data) => {
    var _ListingType$listingT5, _ListingType$listingT6, _item$position2;
    var listingType = data.listingType,
      item = data.item;
    var listingCategory = (_ListingType$listingT5 = (_ListingType$listingT6 = ListingType[listingType]) === null || _ListingType$listingT6 === void 0 ? void 0 : _ListingType$listingT6.category) !== null && _ListingType$listingT5 !== void 0 ? _ListingType$listingT5 : '';
    return ga4.recentSearchEvent({
      recentSearchPosition: (_item$position2 = item.position) !== null && _item$position2 !== void 0 ? _item$position2 : 0,
      label: item.name,
      listingCategory
    });
  },
  'pow-click': (_key, data) => {
    var _ListingType$listingT7, _ListingType$listingT8;
    var listPosition = data.index,
      listingType = data.listingType,
      listing = data.listing;
    var listingCategory = (_ListingType$listingT7 = (_ListingType$listingT8 = ListingType[listingType]) === null || _ListingType$listingT8 === void 0 ? void 0 : _ListingType$listingT8.category) !== null && _ListingType$listingT7 !== void 0 ? _ListingType$listingT7 : '';
    return ga4.propertyOfTheWeekClickEvent({
      listPosition,
      listingAddress: "".concat(listing.address.street, ", ").concat(listing.address.suburb, ", ").concat(listing.address.state, " ").concat(listing.address.postcode),
      listingCategory
    });
  },
  'dream-home-click': (_key, data) => {
    var _ListingType$listingT9, _ListingType$listingT0, _dreamHome$suburb, _dreamHome$state, _dreamHome$attributes, _dreamHome$attributes2, _dreamHome$attributes3, _dreamHome$attributes4, _dreamHome$attributes5, _dreamHome$attributes6;
    var listPosition = data.position,
      dreamHome = data.dreamHome,
      listingType = data.listingType;
    var listingCategory = (_ListingType$listingT9 = (_ListingType$listingT0 = ListingType[listingType]) === null || _ListingType$listingT0 === void 0 ? void 0 : _ListingType$listingT0.category) !== null && _ListingType$listingT9 !== void 0 ? _ListingType$listingT9 : '';
    return ga4.dreamHomeClickEvent({
      listPosition,
      suburb: (_dreamHome$suburb = dreamHome === null || dreamHome === void 0 ? void 0 : dreamHome.suburb) !== null && _dreamHome$suburb !== void 0 ? _dreamHome$suburb : '',
      state: (_dreamHome$state = dreamHome === null || dreamHome === void 0 ? void 0 : dreamHome.state) !== null && _dreamHome$state !== void 0 ? _dreamHome$state : '',
      listingCategory,
      elementText: "".concat(dreamHome === null || dreamHome === void 0 ? void 0 : dreamHome.suburb, ", ").concat(dreamHome === null || dreamHome === void 0 ? void 0 : dreamHome.state, " ").concat((_dreamHome$attributes = (_dreamHome$attributes2 = dreamHome.attributes) === null || _dreamHome$attributes2 === void 0 ? void 0 : _dreamHome$attributes2.bedrooms) !== null && _dreamHome$attributes !== void 0 ? _dreamHome$attributes : 0, ",").concat((_dreamHome$attributes3 = (_dreamHome$attributes4 = dreamHome.attributes) === null || _dreamHome$attributes4 === void 0 ? void 0 : _dreamHome$attributes4.bathrooms) !== null && _dreamHome$attributes3 !== void 0 ? _dreamHome$attributes3 : 0, ",").concat((_dreamHome$attributes5 = (_dreamHome$attributes6 = dreamHome.attributes) === null || _dreamHome$attributes6 === void 0 ? void 0 : _dreamHome$attributes6.carspaces) !== null && _dreamHome$attributes5 !== void 0 ? _dreamHome$attributes5 : 0)
    });
  }
};
export default eventMapper;